import { render, staticRenderFns } from "./TagGamesModal.vue?vue&type=template&id=236d9c52&scoped=true&"
import script from "./TagGamesModal.vue?vue&type=script&lang=js&"
export * from "./TagGamesModal.vue?vue&type=script&lang=js&"
import style0 from "./TagGamesModal.vue?vue&type=style&index=0&id=236d9c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236d9c52",
  null
  
)

export default component.exports